import { createStyles, makeStyles } from '@material-ui/core';

export const useRadioStyles = makeStyles(() =>
    createStyles({
        root: {
            gap: 24,
            cursor: 'pointer',
            display: 'inline-flex',
            flexDirection: 'column'
        },
        optionContainer: {
            gap: 6,
            display: 'flex',
            flexDirection: 'column'
        },
        radioContainer: {
            gap: 8,
            display: 'flex',
            alignItems: 'center'
        },
        optionLabel: {
            fontSize: 16,
            lineHeight: 1,
            fontWeight: 400
        },
        input: {
            margin: 0,
            width: 15,
            height: 15,
            color: '#000000',
            accentColor: '#000000'
        },
        optionDescription: {
            fontSize: 15,
            lineHeight: 1,
            fontWeight: 400,
            color: '#7A7A7A',
            paddingLeft: 24
        }
    })
);
